/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2024-11-21 21:09:11
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from 'react'
import { BsyUtils } from '../../../utils/Utils';
import BsySelect from '../../BsySelect';
import BsyFilterBase from '../BsyFilterBase';

import './index.css'
import { BsyConfig } from '../../../global/BsyConfig';

export class BsyFilterNode extends BsyFilterBase {
    constructor(props) {
        super({
            minRow: 10,
            onStopEdit: null,
            valueMode: window.FX.CONST.FILTER_VALUE_MODE.ITEM,
            customItem: {
                text: React.language("unfilled"),
                value: "hasEmpty"
            },
            ...props
        })

        this.dashText = null;
    }


    _getAvailableMethods = () => {
        return [window.FX.CONST.FILTER_METHOD.IN]
    }


    getValue = () => {
        let t = this.options;
        if (this.dashText) {
            let e = this.dashText.getValue()
                , i = BsyConfig().CONST.FILTER_VALUE_MODE;
            switch (this.valueMode) {
                case i.ITEM:
                    switch (this.method) {
                        case BsyConfig().CONST.FILTER_METHOD.EQ:
                        case BsyConfig().CONST.FILTER_METHOD.NE:
                        case BsyConfig().CONST.FILTER_METHOD.LK:
                        case BsyConfig().CONST.FILTER_METHOD.ULK:
                            return {
                                value: e
                            };
                        case BsyConfig().CONST.FILTER_METHOD.IN:
                        case BsyConfig().CONST.FILTER_METHOD.NIN:
                            if ("checklist" === this._getCompType()) {
                                let a = !1
                                    , n = [];
                                BsyUtils.forEach(e, function (e, i) {
                                    i !== t.customItem.value ? n.push(i) : a = !0
                                })
                                return {
                                    hasEmpty: a,
                                    items: n
                                }
                            }
                            if (BsyUtils.isObjectEmpty(e))
                                return { items: [], hasEmpty: false };
                            let e1 = [].concat(e)
                                , t = !1
                                , i = e.indexOf(BsyConfig().CONST.PARAMETER.EMPTY);
                            if (i > -1) {
                                t = !0
                                e1.splice(i, 1)
                            }
                            return {
                                hasEmpty: t,
                                items: e1
                            }
                        // return e;
                        default:
                            return null
                    }

                case i.CUSTOM:
                    switch (this.method) {
                        case BsyConfig().CONST.FILTER_METHOD.EQ:
                        case BsyConfig().CONST.FILTER_METHOD.NE:
                        case BsyConfig().CONST.FILTER_METHOD.LK:
                        case BsyConfig().CONST.FILTER_METHOD.ULK:
                            return {
                                value: e
                            };
                        case BsyConfig().CONST.FILTER_METHOD.IN:
                        case BsyConfig().CONST.FILTER_METHOD.NIN:
                            return {
                                items: e
                            };
                        default:
                            return null
                    }

                case i.INPUT: {
                    let result = {
                        value: e,
                        likeMatch: this.likeMatch ? this.likeMatch.getValue() : t.defaultConfig.likeMatch,
                    };
                    return result;
                }
                default:
            }
        }
        return null
    }

    getContext = (e) => {
        this.dashText = e;
    }

    renderCont = () => {
        let e = this
        let i = this.options;

        let c = this._getAsyncConfig()
        if (BsyUtils.isObjectEmpty(c)) {
            return <span className='error-tip'>{React.language("field.deleted.tip1")}</span>;
        }
        let val = this.getMiddleValue();
        return <BsySelect
            hasLimit={!0}
            asyncResultKey={i.asyncResultKey || "items"}
            allowBlank={true}
            theme={this.props.theme}
            textField="_id"
            valueField="value"
            height={'34px'}
            onBeforeAsync={i.onBeforeAsync}
            value={val ? val.value : null}
            onStopEdit={e1 => {
                e.value = e.getValue()
                BsyUtils.applyFunc(e, i.onStopEdit, [{
                    value: e.getValue(),
                    valueMode: e.valueMode,
                    method: e.method,
                }, i], !1)
            }}
            getContext={this.getContext}
            async={c}
        />
    }

    render() {
        return (<>
            {
                this.createTitleBar()
            }
            <div className='bsy-dash-cont' >
                {
                    this.renderCont()
                }
            </div>
        </>)
    }

}

